import { X } from "lucide-react"

const CalBookingModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" />

      {/* Modal */}
      <div
        className="relative z-10 w-[80vw] bg-[#1a1a1a] font-satoshi overflow-hidden flex flex-col lg:flex-row"
        style={{ height: "70vh" }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-20 w-8 h-8 flex items-center justify-center rounded-full border border-gray-700 text-gray-400 hover:border-gray-400 hover:text-white transition-colors"
        >
          <X size={14} />
        </button>

        {/* LEFT — info col */}
        <div className="p-8 lg:p-12 flex flex-col justify-between gap-8 lg:w-2/5 border-b lg:border-b-0 lg:border-r border-gray-700 flex-shrink-0">
          <div className="flex flex-col gap-5">
            <p className="text-xs font-medium tracking-[0.2em] uppercase text-purple-400">
              Book a Demo
            </p>
            <h2 className="text-2xl sm:text-3xl text-white font-[300] tracking-tight leading-tight">
              Try Resolut for one of{" "}
              <em className="not-italic text-gray-500">your job posts</em>
            </h2>
            <div className="w-8 h-px bg-gray-700" />
            <p className="text-gray-500 text-sm leading-relaxed font-fustat">
              Pick a time and we'll walk you through the full pipeline —
              screening, AI interviews, reports, and more — live on your own
              role.
            </p>
          </div>

          {/* Trust signals */}
          <div className="flex flex-col gap-3">
            {[
              "30-minute live walkthrough",
              "No commitment required",
              "We'll use one of your real job posts",
            ].map((point) => (
              <div key={point} className="flex items-center gap-3">
                <div className="w-1 h-1 rounded-full bg-purple-400 flex-shrink-0" />
                <span className="text-gray-500 text-xs font-fustat">
                  {point}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT — Cal iframe */}
        <div className="bg-white flex-1 overflow-hidden">
          <iframe
            src="https://cal.com/resolut-ggii2t/resolut-demo?embed=true&hideEventTypeDetails=true&layout=month_view"
            style={{ width: "100%", height: "100%", border: "none" }}
            title="Book a Demo"
          />
        </div>
      </div>
    </div>
  )
}

export default CalBookingModal
